module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module chunks = 2